export class MercadoPagoPointDevice {
  deviceId: string

  posId?: string

  storeId?: string

  operatingMode?: string

  constructor(data: Partial<MercadoPagoPointDevice> = {}) {
    this.deviceId = data.deviceId ?? ""

    this.posId = data.posId

    this.storeId = data.storeId

    this.operatingMode = data.operatingMode
  }
}
